/**
 * @graphql agg
 */
import { graphql } from 'react-relay';

export const ConfluenceFreePoolTargetExperimentAddtlEligibilityQuery = graphql`
	query ConfluenceFreePoolTargetExperimentAddtlEligibilityQuery(
		$cloudId: ID!
		$productKey: String!
	) {
		tenantContexts(cloudIds: [$cloudId]) {
			entitlementInfo(hamsProductKey: $productKey) {
				entitlement {
					latestUsageForChargeElement(chargeElement: "user")
					preDunning {
						status
					}
					transactionAccount {
						isBillToPresent
					}
					subscription {
						trial {
							timeLeft
						}
					}
					... on CcpEntitlement {
						createdAt
					}
					experienceCapabilities {
						changeOfferingV2(offeringName: "standard") {
							isAvailableToUser
							experienceUrl
						}
					}
				}
			}
		}
	}
`;
